import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dateSelect', 'startDateField'];

  declare readonly dateSelectTarget: HTMLSelectElement;
  declare readonly startDateFieldTargets: HTMLInputElement[];

  connect() {
    this.updateAllDateFields();
  }

  updateAllDateFields() {
    const selectedDate = this.dateSelectTarget.value;

    if (selectedDate) {
      this.startDateFieldTargets.forEach((field) => {
        field.value = selectedDate;
      });
    }
  }
}

